export default __webpack_public_path__ + "static/media/a036-1.78716338.svg";